<template>
  <v-form>
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.name"
            :error-messages="nameErrors"
            :label="$t('global.name')"
            required
            @input="$v.item.name.$touch()"
            @blur="$v.item.name.$touch()"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="blocSelectItems"
            v-model="item.blocs"
            :items="blocSelectItems"
            :error-messages="blocsErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            multiple
            :label="$t('administration.profil.blocs')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">

          <v-row align="center">
            <v-col md="8" >
              <strong class="ml-4" >{{ $t('administration.profil.base') }}:</strong>
            </v-col>
            <v-col md="4">
              <v-switch
                v-model="item.base"
                :error-messages="baseErrors"
              ></v-switch>
            </v-col>
          </v-row>
        </v-col>

      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import has from 'lodash/has';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';

export default {
  name: 'ProfilInterfaceForm',
  mixins: [validationMixin],
  props: {
    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
        name: null,
        base: null,
        blocSelectItems:  [
            'printerList',
            'designFileList',
            'orderListDoubleRole',
            'orderListNew',
            'orderList',
          ],
    };
  },
  computed: {

    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },
    nameErrors() {
      const errors = [];

      if (!this.$v.item.name.$dirty) return errors;

      has(this.violations, 'name') && errors.push(this.violations.name);

      !this.$v.item.name.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    baseErrors() {
      const errors = [];
      if (!this.$v.item.base.$dirty) return errors;
      has(this.violations, 'base') && errors.push(this.violations.base);
      return errors;
    },
    blocsErrors() {
      const errors = [];
      if (!this.$v.item.blocs.$dirty) return errors;
      has(this.violations, 'blocs') && errors.push(this.violations.blocs);
      return errors;
    },
    violations() {
      return this.errors || {};
    },
  },
  methods: {


  },
  validations: {
    item: {
      name: {
        required,
      },
      base: {

      },
      blocs: {

      },
    }
  }
};
</script>
